/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poparce.ru/api/dewu/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BrandFilter } from '../models';
// @ts-ignore
import type { BrandsPageableResponseDto } from '../models';
// @ts-ignore
import type { BuyerOrderFilterType } from '../models';
// @ts-ignore
import type { BuyerOrderList } from '../models';
// @ts-ignore
import type { CategoryResultDto } from '../models';
// @ts-ignore
import type { CertInfoResponse } from '../models';
// @ts-ignore
import type { DetailResponseTypeV3 } from '../models';
// @ts-ignore
import type { DetailResponseTypeV5 } from '../models';
// @ts-ignore
import type { DetailWithPricesResponseTypeV5 } from '../models';
// @ts-ignore
import type { ILinkToSpuId } from '../models';
// @ts-ignore
import type { ProductPageResponse } from '../models';
// @ts-ignore
import type { ProductSearchResponse } from '../models';
// @ts-ignore
import type { RelationListResponse } from '../models';
// @ts-ignore
import type { SimpleProductsDetailRequest } from '../models';
// @ts-ignore
import type { SimpleProductsDetailResponse } from '../models';
// @ts-ignore
import type { SkusInfoMap } from '../models';
// @ts-ignore
import type { TraceOrderData } from '../models';
/**
 * DewuApi - axios parameter creator
 * @export
 */
export const DewuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение заказов
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerBuyerOrderList: async (clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('dewuControllerBuyerOrderList', 'clientId', clientId)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('dewuControllerBuyerOrderList', 'pageSize', pageSize)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('dewuControllerBuyerOrderList', 'type', type)
            const localVarPath = `/buyerOrderList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            if (clientId != null) {
                localVarHeaderParameter['client-id'] = String(clientId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение spuId по ссылке из приложения
         * @param {string} link 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerConvertLinkToSpuId: async (link: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'link' is not null or undefined
            assertParamExists('dewuControllerConvertLinkToSpuId', 'link', link)
            const localVarPath = `/convertLinkToSpuId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (link !== undefined) {
                localVarQueryParameter['link'] = link;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение брендов
         * @param {BrandFilter} brandFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetBrands: async (brandFilter: BrandFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandFilter' is not null or undefined
            assertParamExists('dewuControllerGetBrands', 'brandFilter', brandFilter)
            const localVarPath = `/getBrands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение категорий
         * @param {DewuControllerGetCategoriesLangEnum} lang Language code (ZH, RU, EN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetCategories: async (lang: DewuControllerGetCategoriesLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('dewuControllerGetCategories', 'lang', lang)
            const localVarPath = `/getCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сканер сертификатов
         * @param {string} certNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetCertInfo: async (certNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certNo' is not null or undefined
            assertParamExists('dewuControllerGetCertInfo', 'certNo', certNo)
            const localVarPath = `/getCertInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (certNo !== undefined) {
                localVarQueryParameter['certNo'] = certNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetail: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('dewuControllerGetProductDetail', 'spuId', spuId)
            const localVarPath = `/productDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (spuId !== undefined) {
                localVarQueryParameter['spuId'] = spuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetailV3: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('dewuControllerGetProductDetailV3', 'spuId', spuId)
            const localVarPath = `/productDetailV3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (spuId !== undefined) {
                localVarQueryParameter['spuId'] = spuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о товаре и ценах
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetailWithPrice: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('dewuControllerGetProductDetailWithPrice', 'spuId', spuId)
            const localVarPath = `/productDetailWithPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (spuId !== undefined) {
                localVarQueryParameter['spuId'] = spuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получние товаров со скидкой, для 11.11
         * @param {number} pageSize Кол-во товаров на странице
         * @param {number} pageNo Номер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDiscountList: async (pageSize: number, pageNo: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('dewuControllerGetProductDiscountList', 'pageSize', pageSize)
            // verify required parameter 'pageNo' is not null or undefined
            assertParamExists('dewuControllerGetProductDiscountList', 'pageNo', pageNo)
            const localVarPath = `/productDiscountList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['pageNo'] = pageNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение связанных товаров по spuId
         * @param {number} limit 
         * @param {number} spuId 
         * @param {string} [lastId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetRelationList: async (limit: number, spuId: number, lastId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('dewuControllerGetRelationList', 'limit', limit)
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('dewuControllerGetRelationList', 'spuId', spuId)
            const localVarPath = `/productRelationList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }

            if (spuId !== undefined) {
                localVarQueryParameter['spuId'] = spuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение первичной информации о товаре по spuId
         * @param {SimpleProductsDetailRequest} simpleProductsDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetSimpleProductsDetail: async (simpleProductsDetailRequest: SimpleProductsDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simpleProductsDetailRequest' is not null or undefined
            assertParamExists('dewuControllerGetSimpleProductsDetail', 'simpleProductsDetailRequest', simpleProductsDetailRequest)
            const localVarPath = `/productsDetailSimple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simpleProductsDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о цене по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetSkuInfoBySpuId: async (spuId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'spuId' is not null or undefined
            assertParamExists('dewuControllerGetSkuInfoBySpuId', 'spuId', spuId)
            const localVarPath = `/priceInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (spuId !== undefined) {
                localVarQueryParameter['spuId'] = spuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение категорий из stark dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetStarkCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getStarkCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} keyword 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerSearchProducts: async (keyword: string, limit?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('dewuControllerSearchProducts', 'keyword', keyword)
            const localVarPath = `/searchProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отслеживание заказа
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {string} orderNo Номер заказа. Можно получить в запросе, где список заказов (/buyerOrderList)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerTraceOrder: async (clientId: string, orderNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('dewuControllerTraceOrder', 'clientId', clientId)
            // verify required parameter 'orderNo' is not null or undefined
            assertParamExists('dewuControllerTraceOrder', 'orderNo', orderNo)
            const localVarPath = `/traceOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (orderNo !== undefined) {
                localVarQueryParameter['orderNo'] = orderNo;
            }


    
            if (clientId != null) {
                localVarHeaderParameter['client-id'] = String(clientId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DewuApi - functional programming interface
 * @export
 */
export const DewuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DewuApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение заказов
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerBuyerOrderList(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerOrderList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerBuyerOrderList(clientId, pageSize, type, lastId, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerBuyerOrderList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение spuId по ссылке из приложения
         * @param {string} link 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerConvertLinkToSpuId(link: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILinkToSpuId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerConvertLinkToSpuId(link, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerConvertLinkToSpuId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение брендов
         * @param {BrandFilter} brandFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetBrands(brandFilter: BrandFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandsPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetBrands(brandFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение категорий
         * @param {DewuControllerGetCategoriesLangEnum} lang Language code (ZH, RU, EN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetCategories(lang: DewuControllerGetCategoriesLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetCategories(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сканер сертификатов
         * @param {string} certNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetCertInfo(certNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetCertInfo(certNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetCertInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetProductDetail(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailResponseTypeV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetProductDetail(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async dewuControllerGetProductDetailV3(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailResponseTypeV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetProductDetailV3(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetProductDetailV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о товаре и ценах
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetProductDetailWithPrice(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailWithPricesResponseTypeV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetProductDetailWithPrice(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetProductDetailWithPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получние товаров со скидкой, для 11.11
         * @param {number} pageSize Кол-во товаров на странице
         * @param {number} pageNo Номер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetProductDiscountList(pageSize: number, pageNo: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetProductDiscountList(pageSize, pageNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetProductDiscountList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение связанных товаров по spuId
         * @param {number} limit 
         * @param {number} spuId 
         * @param {string} [lastId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetRelationList(limit: number, spuId: number, lastId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetRelationList(limit, spuId, lastId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetRelationList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение первичной информации о товаре по spuId
         * @param {SimpleProductsDetailRequest} simpleProductsDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest: SimpleProductsDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleProductsDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetSimpleProductsDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о цене по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetSkuInfoBySpuId(spuId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkusInfoMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetSkuInfoBySpuId(spuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetSkuInfoBySpuId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение категорий из stark dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerGetStarkCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerGetStarkCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerGetStarkCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} keyword 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerSearchProducts(keyword: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerSearchProducts(keyword, limit, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerSearchProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отслеживание заказа
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {string} orderNo Номер заказа. Можно получить в запросе, где список заказов (/buyerOrderList)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dewuControllerTraceOrder(clientId: string, orderNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceOrderData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dewuControllerTraceOrder(clientId, orderNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DewuApi.dewuControllerTraceOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DewuApi - factory interface
 * @export
 */
export const DewuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DewuApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение заказов
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {number} pageSize Размер страницы (от 5 до 20)
         * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
         * @param {string} [lastId] ID последнего элемента для пагинации
         * @param {string} [keyword] Ключевое слово для поиска заказов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerBuyerOrderList(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerOrderList> {
            return localVarFp.dewuControllerBuyerOrderList(clientId, pageSize, type, lastId, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение spuId по ссылке из приложения
         * @param {string} link 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerConvertLinkToSpuId(link: string, options?: RawAxiosRequestConfig): AxiosPromise<ILinkToSpuId> {
            return localVarFp.dewuControllerConvertLinkToSpuId(link, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение брендов
         * @param {BrandFilter} brandFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetBrands(brandFilter: BrandFilter, options?: RawAxiosRequestConfig): AxiosPromise<BrandsPageableResponseDto> {
            return localVarFp.dewuControllerGetBrands(brandFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение категорий
         * @param {DewuControllerGetCategoriesLangEnum} lang Language code (ZH, RU, EN)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetCategories(lang: DewuControllerGetCategoriesLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.dewuControllerGetCategories(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сканер сертификатов
         * @param {string} certNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetCertInfo(certNo: string, options?: RawAxiosRequestConfig): AxiosPromise<CertInfoResponse> {
            return localVarFp.dewuControllerGetCertInfo(certNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetail(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<DetailResponseTypeV5> {
            return localVarFp.dewuControllerGetProductDetail(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о товаре по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetailV3(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<DetailResponseTypeV3> {
            return localVarFp.dewuControllerGetProductDetailV3(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о товаре и ценах
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDetailWithPrice(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<DetailWithPricesResponseTypeV5> {
            return localVarFp.dewuControllerGetProductDetailWithPrice(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получние товаров со скидкой, для 11.11
         * @param {number} pageSize Кол-во товаров на странице
         * @param {number} pageNo Номер страницы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetProductDiscountList(pageSize: number, pageNo: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductPageResponse> {
            return localVarFp.dewuControllerGetProductDiscountList(pageSize, pageNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение связанных товаров по spuId
         * @param {number} limit 
         * @param {number} spuId 
         * @param {string} [lastId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetRelationList(limit: number, spuId: number, lastId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RelationListResponse> {
            return localVarFp.dewuControllerGetRelationList(limit, spuId, lastId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение первичной информации о товаре по spuId
         * @param {SimpleProductsDetailRequest} simpleProductsDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest: SimpleProductsDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SimpleProductsDetailResponse> {
            return localVarFp.dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о цене по spuId
         * @param {number} spuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetSkuInfoBySpuId(spuId: number, options?: RawAxiosRequestConfig): AxiosPromise<SkusInfoMap> {
            return localVarFp.dewuControllerGetSkuInfoBySpuId(spuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение категорий из stark dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerGetStarkCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryResultDto>> {
            return localVarFp.dewuControllerGetStarkCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров по ключевому слову
         * @param {string} keyword 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerSearchProducts(keyword: string, limit?: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchResponse> {
            return localVarFp.dewuControllerSearchProducts(keyword, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отслеживание заказа
         * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
         * @param {string} orderNo Номер заказа. Можно получить в запросе, где список заказов (/buyerOrderList)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dewuControllerTraceOrder(clientId: string, orderNo: string, options?: RawAxiosRequestConfig): AxiosPromise<TraceOrderData> {
            return localVarFp.dewuControllerTraceOrder(clientId, orderNo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DewuApi - object-oriented interface
 * @export
 * @class DewuApi
 * @extends {BaseAPI}
 */
export class DewuApi extends BaseAPI {
    /**
     * 
     * @summary Получение заказов
     * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
     * @param {number} pageSize Размер страницы (от 5 до 20)
     * @param {BuyerOrderFilterType} type Тип фильтра заказов. Возможные значения:  - **1** - ожидают оплаты - **2** - ожидают отправки - **3** - принято  - **4** - все заказы - **5** - следующий по порядку
     * @param {string} [lastId] ID последнего элемента для пагинации
     * @param {string} [keyword] Ключевое слово для поиска заказов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerBuyerOrderList(clientId: string, pageSize: number, type: BuyerOrderFilterType, lastId?: string, keyword?: string, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerBuyerOrderList(clientId, pageSize, type, lastId, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение spuId по ссылке из приложения
     * @param {string} link 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerConvertLinkToSpuId(link: string, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerConvertLinkToSpuId(link, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение брендов
     * @param {BrandFilter} brandFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetBrands(brandFilter: BrandFilter, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetBrands(brandFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение категорий
     * @param {DewuControllerGetCategoriesLangEnum} lang Language code (ZH, RU, EN)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetCategories(lang: DewuControllerGetCategoriesLangEnum, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetCategories(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сканер сертификатов
     * @param {string} certNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetCertInfo(certNo: string, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetCertInfo(certNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о товаре по spuId
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetProductDetail(spuId: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetProductDetail(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о товаре по spuId
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetProductDetailV3(spuId: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetProductDetailV3(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о товаре и ценах
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetProductDetailWithPrice(spuId: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetProductDetailWithPrice(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получние товаров со скидкой, для 11.11
     * @param {number} pageSize Кол-во товаров на странице
     * @param {number} pageNo Номер страницы
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetProductDiscountList(pageSize: number, pageNo: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetProductDiscountList(pageSize, pageNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение связанных товаров по spuId
     * @param {number} limit 
     * @param {number} spuId 
     * @param {string} [lastId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetRelationList(limit: number, spuId: number, lastId?: string, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetRelationList(limit, spuId, lastId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение первичной информации о товаре по spuId
     * @param {SimpleProductsDetailRequest} simpleProductsDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest: SimpleProductsDetailRequest, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetSimpleProductsDetail(simpleProductsDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о цене по spuId
     * @param {number} spuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetSkuInfoBySpuId(spuId: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetSkuInfoBySpuId(spuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение категорий из stark dewu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerGetStarkCategories(options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerGetStarkCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров по ключевому слову
     * @param {string} keyword 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerSearchProducts(keyword: string, limit?: number, page?: number, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerSearchProducts(keyword, limit, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отслеживание заказа
     * @param {string} clientId ID авторизованного dewu аккаунта на нашем сайте
     * @param {string} orderNo Номер заказа. Можно получить в запросе, где список заказов (/buyerOrderList)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DewuApi
     */
    public dewuControllerTraceOrder(clientId: string, orderNo: string, options?: RawAxiosRequestConfig) {
        return DewuApiFp(this.configuration).dewuControllerTraceOrder(clientId, orderNo, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DewuControllerGetCategoriesLangEnum = {
    Zh: 'ZH',
    Ru: 'RU',
    En: 'EN'
} as const;
export type DewuControllerGetCategoriesLangEnum = typeof DewuControllerGetCategoriesLangEnum[keyof typeof DewuControllerGetCategoriesLangEnum];
